import { render, staticRenderFns } from "./FinancialYearSetup.vue?vue&type=template&id=809d0928&"
import script from "./FinancialYearSetup.vue?vue&type=script&lang=js&"
export * from "./FinancialYearSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports